$(document).ready(function(){
$(".HorizontalList__Item input").change(function(){
var val = $(this).val();
$(".HorizontalList__Item input").each(function(){
var eachval = $(this).val();
if(val == eachval){
$(this).trigger('click');
}
});
});

$(document).on("click",".c_find-store-stock-heading",function() {
$(this).next(".c_find-store-stock-content").slideToggle();
  $(this).find(".c_find-store-stock-plus").toggleClass( "huynh" );
});

$(document).on("click",".c_find-btn-dsktp",function() {
$(".c_find-store-overly").show();
$(".c_find-store-main").show();
$(".Product__Info").addClass("Product__Info-index");
localStorage.setItem("find-color", "find-color");
});
$(document).on("click",".c_find-btn-mbl",function() {
$(".c_find-store-overly").show();
$(".c_find-store-main").addClass("c_find-store-show");
$(".c_find-store-main").removeClass("c_find-store-show-fresh");
$("body").addClass("c_body-lock");
localStorage.setItem("find-color", "find-color");
});
$(document).on("click",".c_find-store-close-dsktp span, .c_find-store-overly",function() {
$(".c_find-store-overly").hide();
$(".c_find-store-main").hide();
$(".Product__Info").removeClass("Product__Info-index");
localStorage.removeItem("find-color");
});
$(document).on("click",".c_find-store-close-mbl span, .c_find-store-overly",function() {
$(".c_find-store-overly").hide();
$(".c_find-store-main").removeClass("c_find-store-show");
$("body").removeClass("c_body-lock");
$(".c_find-store-main").removeClass("c_find-store-show-fresh");
localStorage.removeItem("find-color");
});

function related_popup (){
if ($(window).width() > 1007) {
if(localStorage.getItem("find-color") != null){
$(".c_find-store-overly").show();
$(".c_find-store-main").show();
$(".Product__Info").addClass("Product__Info-index");
}
}

if ($(window).width() <= 1007) {
if(localStorage.getItem("find-color") != null){
$(".c_find-store-overly").show();
$(".c_find-store-main").addClass("c_find-store-show");
$(".c_find-store-main").addClass("c_find-store-show-fresh");
$("body").addClass("c_body-lock");

}
}
else{
$("body").removeClass("c_body-lock");
$(".c_find-store-main").removeClass("c_find-store-show-fresh");
}
}

related_popup ();

$( window ).resize(function() {
related_popup ();
});


  
  
  

});

